goog.provide("shadow.js.shim.module$$mui$x_charts_vendor$d3_interpolate");
goog.provide("module$shadow_js_shim_module$$mui$x_charts_vendor$d3_interpolate");
shadow.js.shim.module$$mui$x_charts_vendor$d3_interpolate = shadow.js.nativeProvides["@mui/x-charts-vendor/d3-interpolate"] = shadow$bridge("@mui/x-charts-vendor/d3-interpolate");
module$shadow_js_shim_module$$mui$x_charts_vendor$d3_interpolate.default = shadow.js.shim.module$$mui$x_charts_vendor$d3_interpolate;
